(function () {
  'use strict';

  var isAr = document.documentElement.lang === 'ar';
  var t = isAr ? {
    title: 'سلة المشتريات', qty: 'الكمية:', subtotal: 'المجموع الفرعي',
    viewCart: 'عرض السلة', checkout: 'إتمام الطلب',
    empty: 'سلتك فارغة', remove: 'حذف من السلة'
  } : {
    title: 'Shopping Cart', qty: 'Qty:', subtotal: 'Subtotal',
    viewCart: 'View Cart', checkout: 'Checkout',
    empty: 'Your cart is empty', remove: 'Remove item'
  };

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      var raw = window.Shopify.formatMoney(cents, '{{amount}}');
      var num = parseFloat(raw.replace(/[^0-9.]/g, ''));
      if (!isNaN(num)) {
        return isAr ? (num.toFixed(2) + ' ر.ع') : ('OMR ' + num.toFixed(2));
      }
    }
    return isAr ? ((cents / 100).toFixed(2) + ' ر.ع') : ('OMR ' + (cents / 100).toFixed(2));
  }

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // ---- Authoritative UI writers (handle duplicate elements safely) ----
  function setBubble(count) {
    document.querySelectorAll('#cart-icon-bubble').forEach(function (bubble) {
      if (count > 0) {
        var c = count < 100 ? count : '99+';
        bubble.innerHTML = '<div class="cart-count-bubble"><span aria-hidden="true">' + c + '</span></div>';
      } else {
        bubble.innerHTML = '';
      }
    });
  }

  function updateHeaderTotal(totalPrice) {
    document.querySelectorAll('.cart-header-total').forEach(function (el) {
      el.textContent = formatMoney(totalPrice);
    });
  }

  function renderPanel(cart) {
    var panel = document.getElementById('cart-dropdown-panel');
    if (!panel) return;

    if (!cart || cart.item_count === 0) {
      panel.innerHTML =
        '<div class="cart-dropdown-header"><span>' + t.title + '</span></div>' +
        '<div class="cart-dropdown-items"><p class="cart-dropdown-empty">' + t.empty + '</p></div>';
      return;
    }

    var itemsHtml = '';
    cart.items.forEach(function (item) {
      var imgSrc = item.image ? item.image.replace(/(\.\w+)(\?.*)?$/, '_80x80_crop_center$1') : '';
      itemsHtml +=
        '<div class="cart-dropdown-item">' +
        (imgSrc ? '<img src="' + esc(imgSrc) + '" alt="' + esc(item.title) + '" width="60" height="60">' : '') +
        '<div class="cart-dropdown-item-info">' +
        '<span class="cart-item-title">' + esc(item.title) + '</span>' +
        '<span class="cart-item-qty">' + t.qty + ' ' + item.quantity + '</span>' +
        '<span class="cart-item-price">' + formatMoney(item.final_line_price) + '</span>' +
        '</div>' +
        '<button class="cart-item-remove" type="button" aria-label="' + t.remove + '" data-key="' + esc(item.key) + '">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">' +
        '<path d="M1 1L9 9M9 1L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
        '</svg></button></div>';
    });

    panel.innerHTML =
      '<div class="cart-dropdown-header"><span>' + t.title + '</span>' +
      '<span class="cart-dropdown-count"> (' + cart.item_count + ')</span></div>' +
      '<div class="cart-dropdown-items">' + itemsHtml + '</div>' +
      '<div class="cart-dropdown-footer">' +
      '<div class="cart-dropdown-total"><span>' + t.subtotal + '</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
      '<a href="/cart" class="cart-dropdown-view">' + t.viewCart + '</a>' +
      '<a href="/checkout" class="cart-dropdown-checkout">' + t.checkout + '</a>' +
      '</div>';

    attachRemoveHandlers(panel);
  }

  // Single atomic update of every cart UI surface from ONE cart object
  function applyCart(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;
    setBubble(cart.item_count);
    updateHeaderTotal(cart.total_price);
    renderPanel(cart);
  }

  // ---- Authoritative sync: ALWAYS reflects the true server cart ----
  var seq = 0;
  function syncCart() {
    var mySeq = ++seq;
    _fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (mySeq !== seq) return; // a newer sync is in flight
        applyCart(cart);
      })
      .catch(function (e) { console.error('Cart sync error', e); });
  }

  // Debounced sync: waits until cart mutations settle, then reads ONCE.
  // This is what makes rapid add/remove bursts converge to the correct count.
  var syncTimer = null;
  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncCart, 350);
  }

  function removeItem(key) {
    _fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { applyCart(cart); scheduleSync(); })
      .catch(function (e) { console.error('Cart remove error', e); });
  }

  function attachRemoveHandlers(scope) {
    (scope || document).querySelectorAll('.cart-item-remove').forEach(function (btn) {
      if (btn.__bound) return;
      btn.__bound = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        removeItem(btn.dataset.key);
      });
    });
  }

  // Native fetch reference captured BEFORE patching (used for our own reads)
  var _fetch = window.fetch.bind(window);

  // Match cart mutations with OR without the .js suffix (theme posts to /cart/add)
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  // Intercept fetch-based mutations
  window.fetch = function () {
    var args = arguments;
    var url = (args[0] && (typeof args[0] === 'string' ? args[0] : args[0].url)) || '';
    var p = _fetch.apply(window, args);
    if (CART_MUTATION.test(url)) {
      p.then(function () { scheduleSync(); }).catch(function () {});
    }
    return p;
  };

  // Intercept XHR-based mutations
  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._cartUrl = url;
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this._cartUrl && CART_MUTATION.test(this._cartUrl)) {
      this.addEventListener('load', function () { scheduleSync(); });
    }
    return _send.apply(this, arguments);
  };

  // React to the theme's own cart events too (authoritative + immediate)
  document.addEventListener('cart:change', function (e) {
    if (e && e.detail && e.detail.cart) { applyCart(e.detail.cart); }
    scheduleSync();
  });
  document.addEventListener('cart:refresh', function () { scheduleSync(); });
  if (typeof window.subscribe === 'function') {
    try { window.subscribe('cart-update', function () { scheduleSync(); }); } catch (err) {}
  }


  // ---- Safar fix: minus (-) removes item when quantity reaches 1 (Remove button stays) ----
  (function () {
    var s = document.createElement('style');
    s.textContent = '#CartDrawer .quantity__button.disabled,cart-drawer .quantity__button.disabled,cart-drawer-items .quantity__button.disabled,cart-items .quantity__button.disabled,#main-cart-items .quantity__button.disabled{pointer-events:auto !important;}';
    (document.head || document.documentElement).appendChild(s);
    document.addEventListener('click', function (e) {
      var tgt = e.target;
      var btn = tgt && tgt.closest ? tgt.closest('.quantity__button[name="minus"]') : null;
      if (!btn) return;
      var cartItems = btn.closest('cart-drawer-items') || btn.closest('cart-items');
      if (!cartItems) return;
      var wrap = btn.closest('quantity-input');
      var input = wrap && wrap.querySelector('input[name="updates[]"]');
      if (!input) return;
      if (parseInt(input.value, 10) === 1) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var line = input.dataset.index;
        if (line && typeof cartItems.updateQuantity === 'function') { cartItems.updateQuantity(line, 0); }
      }
    }, true);
  })();

  function init() {
    attachRemoveHandlers();
    syncCart();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
